<template>
	<div>
		<div v-for="(error, index) in errors" v-bind:key="index" class="text-danger">
			{{ error }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'InputErrors',
	props: {
		errors: {
			required: true,
			type: Object
		},
	},
}
</script>
